import React from "react";
import { cloneDeep, sortBy } from "lodash";

import { Direction } from "@enums/direction";
import { filterDataByDate } from "@utils/filterDataByDate";
import { buildStatsFilters } from "@utils/buildStatsFilters";

import type { FC } from "react";
import type { StatsTableProps } from "@components/organisms/StatsTable";

function withFiltration(WrappedComponent: FC<StatsTableProps>) {
  return function ComponentWithFiltration({
    sort,
    filters,
    statistic,
    dateRange,
    isStatisticCollapsed,
  }: StatsTableProps) {
    let modifiedStatistic = cloneDeep(statistic);

    modifiedStatistic = buildStatsFilters(modifiedStatistic, filters);
    modifiedStatistic = filterDataByDate(
      modifiedStatistic,
      dateRange!.start,
      dateRange!.end,
      "delDate",
    );

    modifiedStatistic = sortBy(modifiedStatistic, sort.orderBy);

    modifiedStatistic =
      sort.direction === Direction.Asc
        ? modifiedStatistic
        : modifiedStatistic.reverse();

    return (
      <WrappedComponent
        sort={sort}
        statistic={modifiedStatistic}
        isStatisticCollapsed={isStatisticCollapsed}
      />
    );
  };
}

export default withFiltration;
